import Path from "../../../services/paths";
import TargetTrackerActions from "../../prat_actions/targetTracker/targetTrackerActions";
import utils from "../../common/utils";
import axios from "axios";
import CustomToast from '../../../util-functions/customToast.jsx'

class TargetTrackerMiddleware {
    static getTargetTrackerYTDBrand(
        selectedProductCategories,
        selectedProductBrands,
        selectedProductMasterSkus
    ) {

        let url = `${Path.GET_TARGET_YTD_BRAND}?`;

        if (Array.isArray(selectedProductCategories)) {
            selectedProductCategories.forEach(element => {
                url += `category=${element}&`;
            });
        }

        if (Array.isArray(selectedProductBrands)) {
            selectedProductBrands.forEach(element => {
                url += `brand=${element}&`;
            });
        }

        if (Array.isArray(selectedProductMasterSkus)) {
            selectedProductMasterSkus.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }


        url = url.slice(0, -1);

        return dispatch => {
            dispatch(TargetTrackerActions.targetTrackerYTDBrandRequest());

            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.status === 404) {
                                dispatch(TargetTrackerActions.targetTrackerYTDBrandFailed());
                            } else {
                                dispatch(TargetTrackerActions.targetTrackerYTDBrandSuccessul(res));
                            }
                        })
                        .catch(error => {
                            dispatch(TargetTrackerActions.targetTrackerYTDBrandFailed());
                        });
                })
                .catch(error => {
                    dispatch(TargetTrackerActions.targetTrackerYTDBrandFailed(error));
                });
        };
    };
    
    static getTargetTrackerYTDBrandMTFTS(
        selectedProductCategories,
        selectedProductBrands,
        selectedProductMasterSkus
    ) {

        let url = `${Path.GET_TARGET_YTD_BRAND_MTFTS}?`;

        if (Array.isArray(selectedProductCategories)) {
            selectedProductCategories.forEach(element => {
                url += `category=${element}&`;
            });
        }

        if (Array.isArray(selectedProductBrands)) {
            selectedProductBrands.forEach(element => {
                url += `brand=${element}&`;
            });
        }

        if (Array.isArray(selectedProductMasterSkus)) {
            selectedProductMasterSkus.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }


        url = url.slice(0, -1);

        return dispatch => {
            dispatch(TargetTrackerActions.targetTrackerYTDBrandMTFTSRequest());

            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.status === 404) {
                                dispatch(TargetTrackerActions.targetTrackerYTDBrandMTFTSFailed());
                            } else {
                                dispatch(TargetTrackerActions.targetTrackerYTDBrandMTFTSSuccessul(res));
                            }
                        })
                        .catch(error => {
                            dispatch(TargetTrackerActions.targetTrackerYTDBrandMTFTSFailed());
                        });
                })
                .catch(error => {
                    dispatch(TargetTrackerActions.targetTrackerYTDBrandMTFTSFailed(error));
                });
        };
    };

    static getTargetTrackerYTDBrandANP(
        selectedProductCategories,
        selectedProductBrands,
        selectedProductMasterSkus
    ) {

        let url = `${Path.GET_TARGET_YTD_BRAND_ANP}?`;

        if (Array.isArray(selectedProductCategories)) {
            selectedProductCategories.forEach(element => {
                url += `category=${element}&`;
            });
        }

        if (Array.isArray(selectedProductBrands)) {
            selectedProductBrands.forEach(element => {
                url += `brand=${element}&`;
            });
        }

        if (Array.isArray(selectedProductMasterSkus)) {
            selectedProductMasterSkus.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }


        url = url.slice(0, -1);

        return dispatch => {
            dispatch(TargetTrackerActions.targetTrackerYTDBrandANPRequest());

            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.status === 404) {
                                dispatch(TargetTrackerActions.targetTrackerYTDBrandANPFailed());
                            } else {
                                dispatch(TargetTrackerActions.targetTrackerYTDBrandANPSuccessul(res));
                            }
                        })
                        .catch(error => {
                            dispatch(TargetTrackerActions.targetTrackerYTDBrandANPFailed());
                        });
                })
                .catch(error => {
                    dispatch(TargetTrackerActions.targetTrackerYTDBrandANPFailed(error));
                });
        };
    };

    static getTargetTrackerTotalSpent() {

        let url = `${Path.GET_TARGET_TOTAL_SPENT}`;

        return dispatch => {
            dispatch(TargetTrackerActions.targetTrackerTotalSpentRequest());

            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.status === 404) {
                                dispatch(TargetTrackerActions.targetTrackerTotalSpentFailed());
                            } else {
                                dispatch(TargetTrackerActions.targetTrackerTotalSpentSuccessul(res));
                            }
                        })
                        .catch(error => {
                            dispatch(TargetTrackerActions.targetTrackerTotalSpentFailed());
                        });
                })
                .catch(error => {
                    dispatch(TargetTrackerActions.targetTrackerTotalSpentFailed(error));
                });
        };
    };

    static downloadTTXlx(
        selectedCategory,
        selectedBrand,
        selectedSku
    ) {
        let url = `${Path.DOWNLOAD_TARGET_TRACKER_XLSX}?`;

        if (Array.isArray(selectedCategory)) {
            selectedCategory.forEach(element => {
                url += `category=${element}&`;
            });
        }

        if (Array.isArray(selectedBrand)) {
            selectedBrand.forEach(element => {
                url += `brand=${element}&`;
            });
        }

        if (Array.isArray(selectedSku)) {
            selectedSku.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }

        url = url.slice(0, -1);


        return dispatch => {
            dispatch(TargetTrackerActions.downloadTTXlxRequest());

            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        responseType: 'blob',
                        headers: {
                            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.status === 200) {
                                let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=') + 1,)
                                const url = window.URL.createObjectURL(new Blob([res.data]));
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download', fileName); //or any other extension
                                document.body.appendChild(link);
                                link.click();
                                CustomToast('success', 'Download Successful')
                                dispatch(TargetTrackerActions.downloadTTXlxSuccessul(res));
                            } else {
                                CustomToast('error', 'Download Failed!')
                                dispatch(TargetTrackerActions.downloadTTXlxFailed('error'));
                            }
                        })
                        .catch(error => {
                            CustomToast('error', 'Download Failed!')
                            dispatch(TargetTrackerActions.downloadTTXlxFailed(error));
                        });
                })
                .catch(error => {
                    dispatch(TargetTrackerActions.downloadTTXlxFailed(error));
                });
        };
    }
    
    static getTargetTrackerDTTSBrand(
        selectedProductCategories,
        selectedProductBrands,
        selectedProductMasterSkus
    ) {

        let url = `${Path.GET_TARGET_DTTS_BRAND}?`;

        if (Array.isArray(selectedProductCategories)) {
            selectedProductCategories.forEach(element => {
                url += `category=${element}&`;
            });
        }

        if (Array.isArray(selectedProductBrands)) {
            selectedProductBrands.forEach(element => {
                url += `brand=${element}&`;
            });
        }

        if (Array.isArray(selectedProductMasterSkus)) {
            selectedProductMasterSkus.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }


        url = url.slice(0, -1);

        return dispatch => {
            dispatch(TargetTrackerActions.dttsBrandLevelRequest());

            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.status === 404) {
                                dispatch(TargetTrackerActions.dttsBrandLevelFailed());
                            } else {
                                dispatch(TargetTrackerActions.dttsBrandLevelSuccessul(res));
                            }
                        })
                        .catch(error => {
                            dispatch(TargetTrackerActions.dttsBrandLevelFailed());
                        });
                })
                .catch(error => {
                    dispatch(TargetTrackerActions.dttsBrandLevelFailed(error));
                });
        };
    };
}

export default TargetTrackerMiddleware;
